import { useEffect, useState } from "react"
import { useSearchParams, useNavigate } from "react-router"
import { EnkIWPServerAuth as ApiAuth } from "../api/api-iwp-server"
import { loginResultToUser } from "../api/api-utils"
import { useAuth } from "../auth/use-auth"

export default function EnkAutoLogin() {
  const [searchParams] = useSearchParams()
  const navigate = useNavigate()
  const { onLoggedIn } = useAuth()
  const [error, setError] = useState<string | null>(null)

  const token = searchParams.get("token") || ""
  const redirect = searchParams.get("redirect") || "/dashboard"

  useEffect(() => {
    if (!token) {
      setError("Geen token opgegeven")
      return
    }

    ApiAuth.autoLogin(token)
      .then((result) => {
        if (result.user) {
          var user = loginResultToUser(result.user)
          onLoggedIn(user, false)
          navigate(redirect, { replace: true })
        } else {
          setError("Inloggen mislukt")
        }
      })
      .catch((err) => {
        console.error("Auto-login failed:", err)
        setError("Auto-login mislukt. Het token is mogelijk verlopen.")
        setTimeout(() => navigate("/login", { replace: true }), 3000)
      })
  }, [token])

  if (error) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <div className="text-center">
          <p className="text-sm text-red-600">{error}</p>
          <p className="mt-2 text-xs text-gray-500">U wordt doorgestuurd naar de inlogpagina...</p>
        </div>
      </div>
    )
  }

  return (
    <div className="flex min-h-screen items-center justify-center">
      <p className="text-sm text-gray-500">Bezig met inloggen...</p>
    </div>
  )
}
